export const ADMIN_LEAVE_ROLES = ["PRINCIPAL", "SCHOOL_ADMIN", "ADMIN"];
export const LEAVE_STATUSES = ["ALL", "PENDING", "APPROVED", "REJECTED", "CANCELLED"];
export const LEAVE_TYPES = ["SICK", "CASUAL", "EMERGENCY", "EARNED", "MATERNITY", "PATERNITY", "UNPAID"];

export const canReviewLeave = (leave) => leave.status === "PENDING" && leave.isCancelled !== true;

export const formatLeaveDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleDateString("en-US", {
    month: "short", day: "numeric", year: "numeric",
    ...(value.length === 10 ? { timeZone: "UTC" } : {}),
  });
};

export const formatLeaveTimestamp = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString("en-US", {
    month: "short", day: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit",
  });
};
